import { useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";

// Legacy Shopify URL → new site 301-style client redirects
const MAP = {
  "/collections/all": "/shop",
  "/pages/contact": "/contact",
  "/pages/about": "/about",
  "/pages/about-us": "/about",
  "/pages/faq": "/faq",
  "/pages/support": "/support",
  "/pages/blog": "/blog",
  "/policies/refund-policy": "/refund-policy",
  "/policies/privacy-policy": "/privacy-policy",
  "/policies/terms-of-service": "/terms-of-service",
  "/policies/shipping-policy": "/shipping-policy",
  "/apps/orders": "/track",
};

export default function ShopifyRedirects({ children }) {
  const location = useLocation();
  const pathname = location.pathname.toLowerCase();

  // /collections/[handle] -> /shop?category=[handle]
  if (pathname.startsWith("/collections/") && pathname !== "/collections/all") {
    const handle = pathname.replace("/collections/", "").split("/")[0];
    return <Navigate to={`/shop?category=${handle}`} replace />;
  }
  // /products/[handle] stays the same — we already use /products
  if (MAP[pathname]) return <Navigate to={MAP[pathname]} replace />;

  return children;
}
